import { AfterViewInit, Component, inject, OnInit } from '@angular/core';
import { ActionButtonsComponent } from "../edit-route/components/action-buttons/action-buttons.component";
import { TranslateModule } from '@ngx-translate/core';
import { LocalStorageService } from 'src/app/services/localStorage.service';
import { ScrollService } from 'src/app/services/scroll.service';
import { EditRouteService } from './services/edit-route.service';
import { editedCustomRouteAdapter } from './adapters/edited-custom-route.adapter';
import { CustomRouteService } from 'src/app/pages/custom-route/services/custom-route.service';
import { PlannerViewsStateService } from '../../services';
import { PointsComponent, BannerInfoComponent, EditInfoComponent } from "./components";

@Component({
  selector: 'app-edit-route',
  standalone: true,
  imports: [
    TranslateModule,
    ActionButtonsComponent,
    BannerInfoComponent,
    EditInfoComponent,
    PointsComponent,
],
  templateUrl: './edit-route.component.html',
  styleUrls: ['./edit-route.component.scss'],
})
export class EditRouteComponent implements OnInit, AfterViewInit {  
  // Service injections
  private _customRouteService = inject(CustomRouteService);
  private _editRouteService = inject(EditRouteService);
  private _localStorageService = inject(LocalStorageService);
  private _scrollService = inject(ScrollService);
  private _plannerViewStateService = inject(PlannerViewsStateService);
  
  // State service signals
  private _customRouteData = this._customRouteService.customRouteData;
  private _customRouteEditedDataToRender = this._editRouteService.customRouteEditedDataToRender;

  // Local properties
  public showBanner: boolean = true;
  public showEditInfo = this._localStorageService.getItem<boolean>('showEditInfo') ?? true;
  
  // Lifecycle hooks
  ngOnInit(): void {
    this._plannerViewStateService.isEditRouteView.set(true);
    
    // initialize custom route edited data to send adapting the custom route data
    const editedCustomRouteAdapted = editedCustomRouteAdapter(this._customRouteData()); 
    this._editRouteService.setCustomRouteditedDataToSend(editedCustomRouteAdapted);
    
    // initialize custom route edited data to render with the same data
    this._editRouteService.setCustomRouteditedDataToRender(this._editRouteService.customRouteEditedDataToSend());
    
    // initilize initial state custom route edited data to render to check if there are changes (Update button state)
    this._editRouteService.setInitialStateCustomRouteditedDataToRender(this._customRouteEditedDataToRender())
    
    // set isScrolled to false due to the actions affected by the scroll is only for the planner view
    this._scrollService.setIsScrolled(false);
  }
  
  ngAfterViewInit(): void {
    const el: HTMLElement = document.querySelector('app-planner');
    if (!el) return;
    
    this._scrollService.autoScrollToTop(el);
  }
  
  ngOnDestroy(): void {
    this._plannerViewStateService.isEditRouteView.set(false);
  }
  
  // Methods
  public closeBanner() {
    this.showBanner = false;
  }
  
  public closeEditInfo() {
    this.showEditInfo = false;
  }
  
  public openEditInfo() {
    this.showEditInfo = true;
  }
  
  public gotItEditInfo() {
    this.showEditInfo = false;
    this._localStorageService.setItem('showEditInfo', false);
  }
}
